import * as React from 'react'

import { ArrowRightIcon } from 'lucide-react'
import { classList } from 'react-classlist-helper'

interface IFieldMappingRow {
  left: JSX.Element
  right: JSX.Element
  key: string
}

interface IProps {
  leftHeaderRow1: JSX.Element
  rightHeaderRow1: JSX.Element
  leftHeaderRow2: JSX.Element
  rightHeaderRow2: JSX.Element
  rows: IFieldMappingRow[]
  rightHeaderActions?: JSX.Element
}

export default class FieldMappingTable extends React.Component<IProps> {
  public render(): JSX.Element {
    const {
      leftHeaderRow1,
      rightHeaderRow1,
      leftHeaderRow2,
      rightHeaderRow2,
      rows,
      rightHeaderActions,
    } = this.props

    return (
      <div className="brada4 px10 mt15 bg-palette-brand-lightest ba-palette-brand-lighter">
        <div>
          {this.renderHeader(
            leftHeaderRow1,
            rightHeaderRow1,
            leftHeaderRow2,
            rightHeaderRow2,
            rightHeaderActions,
          )}
          {rows.map((row, index) =>
            this.renderRow(row, index, rows.length, !!rightHeaderActions),
          )}
        </div>
      </div>
    )
  }

  private renderHeader = (
    leftHeaderRow1: JSX.Element,
    rightHeaderRow1: JSX.Element,
    leftHeaderRow2: JSX.Element,
    rightHeaderRow2: JSX.Element,
    rightHeaderActions?: JSX.Element,
  ): JSX.Element => {
    return (
      <div className="py10 bb-light-input-border">
        <div className="row pb10">
          <div>{leftHeaderRow1}</div>
          <div className="not-visible row px12 no-grow">
            <ArrowRightIcon size={10} />
          </div>
          <div>{rightHeaderRow1}</div>
          {rightHeaderActions && (
            <div className="row px10 no-grow relative">
              {rightHeaderActions}
            </div>
          )}
        </div>
        <div className="row">
          <div>{leftHeaderRow2}</div>
          <div className="not-visible row px12 no-grow">
            <ArrowRightIcon size={10} />
          </div>
          <div>{rightHeaderRow2}</div>
          {rightHeaderActions && <div className="row px10 no-grow" />}
        </div>
      </div>
    )
  }

  private renderRow = (
    row: IFieldMappingRow,
    index: number,
    totalRows: number,
    hasActions?: boolean,
  ): JSX.Element => {
    const isLastRow = index === totalRows - 1
    return (
      <div
        key={row.key}
        className={classList({
          'row y-stretch': true,
          'bb-light-grey': !isLastRow,
        })}
        style={{ minHeight: '30px' }}
      >
        <div className="row px10 y-center">{row.left}</div>
        <div className="row px12 no-grow x-center br-light-input-border bl-light-input-border">
          <ArrowRightIcon size={10} className="tw:text-muted-foreground" />
        </div>
        <div className="row px10 y-center">{row.right}</div>
        {hasActions && <div className="row px10 no-grow" />}
      </div>
    )
  }
}
